import { makeStyles } from '@material-ui/core/styles';
import { DSTheme } from '../../styles/themes/types';

export const useNavHeaderStyles = makeStyles((theme: DSTheme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.navigation,
    height: '80px',
    position: 'fixed',
    zIndex: 1501,
    top: 0,
    width: '100%',
    borderBottom: '1px solid rgba(146, 146, 150, 0.35)',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    maxWidth: '920px',
    margin: '0 40px',
    color: theme.palette.text.primary,
  },
  logo: {
    display: 'grid',
    placeItems: 'center',
    border: '1px solid',
    borderColor: theme.palette.text.primary,
    borderRadius: '50%',
    width: '38px',
    height: '38px',
    marginRight: '16px',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  links: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: '64px',
    alignItems: 'center',

    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },

    '& a:not(:first-child)': {
      marginLeft: '72px',
    },
  },
  login: {
    color: theme.palette.type === 'dark' ? theme.palette.text.primary : theme.palette.primary.main,
    marginRight: '32px',
  },
  createAccount: {
    width: '160px',
  },
  spacer: {
    flexGrow: 1,
  },
  burger: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

export const useDrawerStyles = makeStyles((theme: DSTheme) => ({
  drawer: {
    gridTemplateColumns: '100px 100px 100px 200px',
    position: 'fixed',
    zIndex: 1501,
    top: '104px',
    right: 0,
    maxWidth: '256px',
    borderBottomLeftRadius: '16px',

    backgroundColor: theme.palette.background.navigation,
    boxShadow: '0px 5px 45px rgba(128, 129, 145, 0.18)',

    [theme.breakpoints.up('md')]: {
      display: 'none',
    },

    [theme.breakpoints.up('sm')]: {
      maxWidth: theme.breakpoints.values.lg,
      borderBottomLeftRadius: 0,
    },
  },
  link: {
    cursor: 'pointer',
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
    letterSpacing: 'normal',
    textAlign: 'center',

    '& .login': {
      color: theme.palette.primary.main,
      marginRight: '32px',
    },
  },
  createAccount: {
    width: '168px',
    height: '48px',
  },
}));
